import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Avatar from '@material-ui/core/Avatar'
import red from '@material-ui/core/colors/red'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Clear from '@material-ui/icons/Clear'
import { isEmpty } from 'ramda';

const styles = theme => ({
  card: {
    width: '100%',
    marginBottom: 10,
    position: 'sticky',
    top: 0,
    zIndex: 1000
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff'
  },
  avatar: {
    backgroundColor: '#fff',
    color: theme.palette.primary.main
  },
  actions: {
    justifyContent: 'flex-end'
  },
  button: {
    backgroundColor: red[700],
    color: '#fff',
    margin: 5
  },
  icon: {
    marginLeft: 2
  },
  noSelection: {
    color: red[700],
    marginLeft: 16
  }
})

class PackBuilderCart extends Component {
  
  calculateTotals = () => {
    const { selectedBasePack, selectedAddOns } = this.props;

    return {
      weight:  (!isEmpty(selectedBasePack) ? selectedBasePack.weight : 0) + 
                    (selectedAddOns.reduce((total, addOn) => {  return total + addOn.selectedValue.weight}, 0)),
  
      cost:  (!isEmpty(selectedBasePack) ? selectedBasePack.cost : 0) + 
                  (selectedAddOns.reduce((total, addOn) => {  return total + addOn.selectedValue.cost}, 0)),  
  
      volume:  (!isEmpty(selectedBasePack) ? selectedBasePack.volume.total : 0) + 
                    (selectedAddOns.reduce((total, addOn) => {  return total + addOn.selectedValue.volume}, 0)),        
    }
  }
  
  render () {
    const { classes, selectedBasePack, selectedBaseOptions, selectedAddOns, removeBasePack, removeBaseOption, removeAddOn } = this.props
    const totals = this.calculateTotals();

    return (
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <Avatar aria-label="Pack Builder" className={classes.avatar}>
              KS
            </Avatar>
          }
          title="Pack Builder"
          subheader="Current Selections"
          subheaderTypographyProps={{color: '#fff'}}
        />
        <CardContent>
          <Typography variant="h6">
            Base Pack:
          </Typography>
          { !selectedBasePack.name && 
            <Typography className={classes.noSelection} variant="subtitle1">
                No Pack Selected
            </Typography>
          }
          { selectedBasePack.name &&
            <Button size="small" aria-label="Delete" variant="contained" color="primary" className={classes.button} onClick={() => removeBasePack(selectedBasePack)}>
              { selectedBasePack.name } <Clear className={classes.icon}/>
            </Button>
          }
          <Typography variant="h6">
            Base Pack Options:
          </Typography>
          { selectedBaseOptions.length === 0 && 
            <Typography className={classes.noSelection} variant="subtitle1">
                No Base Pack Options Selected
            </Typography>
          }
          { selectedBaseOptions.length !== 0 && 
            selectedBaseOptions.map(option => {
              return <Button size="small" aria-label="Delete" variant="contained" color="primary" className={classes.button} key={option.name} onClick={() => removeBaseOption(option)}>
                { `${option.name}: ${option.selectedValue.name}` } <Clear className={classes.icon}/>
              </Button>
            })
          }
          <Typography variant="h6">
            Additional Pack Options:
          </Typography>
          { selectedAddOns.length === 0 && 
            <Typography className={classes.noSelection} variant="subtitle1">
                No Add Ons Selected
            </Typography>
          }
          { selectedAddOns.length !== 0 && 
            selectedAddOns.map(option => {
              return <Button size="small" aria-label="Delete" variant="contained" color="primary" className={classes.button} key={option.name} onClick={() => removeAddOn(option)}>
                { `${option.name}: ${option.selectedValue.name}` } <Clear className={classes.icon}/>
              </Button>
            })
          }
          <hr />
          <Typography variant="body2">
            Base Weight: <strong>{selectedBasePack.weight ? selectedBasePack.weight : 0}g</strong> | 
            Total Weight: <strong>{totals.weight}g</strong> | 
            Total Volume: <strong>{totals.volume}L</strong> | 
            Total Cost: <strong>{totals.cost}¥</strong>
          </Typography>
        </CardContent>
        <CardActions className={classes.actions}>
          <Button size="small" variant="contained" color="primary">Checkout</Button>
        </CardActions>
      </Card>
    )
  }
}

export default withStyles(styles)(PackBuilderCart)